module.exports = __webpack_public_path__ + "images/img_2_2-8f4a126f53.png";